import { Star } from "lucide-react";

const REVIEWS = [
  {
    name: "Michał",
    city: "Warszawa",
    text: "Szybki kontakt i wszystko jasno wyjaśnione.",
  },
  {
    name: "Tomasz",
    city: "Piaseczno",
    text: "Montaż przebiegł sprawnie i bez problemów.",
  },
  {
    name: "Anna",
    city: "Radom",
    text: "Dobra komunikacja i konkretny proces.",
  },
];

export default function ReviewsSection() {
  return (
    <section
      id="opinie"
      className="py-16 lg:py-24 bg-brand-surface"
      data-testid="reviews-section"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-brand-blue">
            Opinie klientów
          </p>
          <h2 className="mt-3 font-heading font-bold text-3xl sm:text-4xl tracking-tight text-brand-ink">
            Co mówią klienci
          </h2>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
          {REVIEWS.map((r, idx) => (
            <article
              key={idx}
              className="bg-white border border-brand-border rounded-2xl p-6 sm:p-7 shadow-sm hover:shadow-md transition-shadow"
              data-testid={`review-${idx}`}
            >
              <div className="flex items-center gap-1">
                {[0, 1, 2, 3, 4].map((i) => (
                  <Star key={i} className="h-4 w-4 fill-brand-yellow text-brand-yellow" />
                ))}
              </div>
              <p className="mt-4 text-brand-ink leading-relaxed">
                “{r.text}”
              </p>
              <p className="mt-5 text-sm text-brand-muted">
                <span className="font-heading font-semibold text-brand-ink">{r.name}</span>
                {" · "}
                {r.city}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
